<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedHireStatuses"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Hire status')"
      :list="hireStatuses"
      :placeholder="$t('All hire statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { HireActiveStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { hireStatusOption } from '@/components/GraphqlDataTable/filters/hires/hireStatusOptions'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

defineProps<{ meta: FilterMetaDataProp }>()

const { hasWorkerCapabilities } = useAccountCapabilities()

const selectedHireStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const orderedStatuses = computed(() => {
  const statuses = [
    HireActiveStatus.Offered,
    HireActiveStatus.Active,
    HireActiveStatus.Ready,
    HireActiveStatus.Ended,
    HireActiveStatus.Terminated,
  ]

  if (!hasWorkerCapabilities.value) {
    statuses.unshift(HireActiveStatus.Draft)
    statuses.push(HireActiveStatus.Cancelled)
  }

  return statuses
})

const hireStatuses = computed(() => orderedStatuses.value.map(hireStatusOption))
</script>
